import React from "react";
import { useParams } from "react-router-dom";
import WayfinderLayout from "./WayfinderLayout";
import BulkVideoUpload from "./BulkVideoUpload";

const VideosPage = ({ buttonColor, currentLanguage }) => {
  const { userId } = useParams();
  return <BulkVideoUpload userId={userId} buttonColor={buttonColor} currentLanguage={currentLanguage} />;
};

// Wrap with layout
const VideosPageWithLayout = () => (
  <WayfinderLayout>
    <VideosPage />
  </WayfinderLayout>
);

export default VideosPageWithLayout;
